const FileNamePrefix = {
  CswAppCss: 'csw-css-',
  AdEngageCss: 'csw-css-ae-',
  PositionableStyle: 'csw-style-positionable-',
  WidgetCss: 'csw-widget-css-',
  EditablePositionCss: 'csw-editable-position-css-',
  EditablePositionScript: 'csw-editable-position-script-',
  EditableScript: 'csw-editable-script-',
  EditableToolsCss: 'csw-editable-tools-css-'
};

export default FileNamePrefix;
